import { Moment } from 'moment';
import { ModelBase } from '../abstract/model-base.model';
import { Currency } from '../core/currency.model';
import { Partner } from '../partner/partner.model';
import { LedgerEntryType } from './ledger-entry-type.model';

export class LedgerEntry extends ModelBase {

    static override CLASS_NAME: string = 'LedgerEntry';

    private _amount!: number;
    private _amountMatched!: number;
    private _amountMatchedOrg!: number;
    private _amountOrg!: number;
    private _amountUnmatched!: number;
    private _amountUnmatchedOrg!: number;
    private _cancelled!: boolean;
    private _currency!: Currency;
    private _date!: Moment;
    private _debitCredit!: string;
    private _draft!: boolean;
    private _dueDate!: Moment;
    private _exchangeRate!: number;
    private _isSettled!: boolean;
    private _objectId!: number;
    private _partner!: Partner;
    private _reference!: string;
    private _sourceObjectType!: string;
    private _type!: LedgerEntryType;

    public get amount(): number {
        return this._amount;
    }

    public set amount(value: any) {
        this._setValue('_amount', value, 'float');
    }

    public get amountMatched(): number {
        return this._amountMatched;
    }

    public set amountMatched(value: any) {
        this._setValue('_amountMatched', value, 'float');
    }

    public get amountMatchedOrg(): number {
        return this._amountMatchedOrg;
    }

    public set amountMatchedOrg(value: any) {
        this._setValue('_amountMatchedOrg', value, 'float');
    }

    public get amountOrg(): number {
        return this._amountOrg;
    }

    public set amountOrg(value: any) {
        this._setValue('_amountOrg', value, 'float');
    }

    public get amountUnmatched(): number {
        return this._amountUnmatched;
    }

    public set amountUnmatched(value: any) {
        this._setValue('_amountUnmatched', value, 'float');
    }

    public get amountUnmatchedOrg(): number {
        return this._amountUnmatchedOrg;
    }

    public set amountUnmatchedOrg(value: any) {
        this._setValue('_amountUnmatchedOrg', value, 'float');
    }

    public get cancelled(): boolean {
        return this._cancelled;
    }

    public set cancelled(value: any) {
        this._setValue('_cancelled', value, 'boolean');
    }

    public get currency(): Currency {
        return this._currency;
    }

    public set currency(value: any) {
        this._setValue('_currency', value, 'Currency');
    }

    public get date(): Moment {
        return this._date;
    }

    public set date(value: any) {
        this._setValue('_date', value, 'date');
    }

    public get debitCredit(): string {
        return this._debitCredit;
    }

    public set debitCredit(value: any) {
        this._setValue('_debitCredit', value, 'string');
    }

    public get draft(): boolean {
        return this._draft;
    }

    public set draft(value: any) {
        this._setValue('_draft', value, 'boolean');
    }

    public get dueDate(): Moment {
        return this._dueDate;
    }

    public set dueDate(value: any) {
        this._setValue('_dueDate', value, 'date');
    }

    public get exchangeRate(): number {
        return this._exchangeRate;
    }

    public set exchangeRate(value: any) {
        this._setValue('_exchangeRate', value, 'float', { precision: 5});
    }

    public get isSettled(): boolean {
        return this._isSettled;
    }

    public set isSettled(value: any) {
        this._setValue('_isSettled', value, 'boolean');
    }

    public get objectId(): number {
        return this._objectId;
    }

    public set objectId(value: any) {
        this._setValue('_objectId', value, 'integer');
    }

    public get partner(): Partner {
        return this._partner;
    }

    public set partner(value: any) {
        this._setValue('_partner', value, 'Partner');
    }

    public get reference(): string {
        return this._reference;
    }

    public set reference(value: any) {
        this._setValue('_reference', value, 'string');
    }

    public get sourceObjectType(): string {
        return this._sourceObjectType;
    }

    public set sourceObjectType(value: any) {
        this._setValue('_sourceObjectType', value, 'string');
    }

    public get type(): LedgerEntryType {
        return this._type;
    }

    public set type(value: any) {
        this._setValue('_type', value, 'LedgerEntryType');
    }
}
